// Shared CSS Grid layout for retailer list header and rows
export const RETAILER_LIST_GRID = {
    display: 'grid',
    gridTemplateColumns: '2fr 1.5fr 1.5fr 1.5fr 100px 140px 140px',
    gap: '8px',
    alignItems: 'center',
    width: '100%',
};
